export let appStyle = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: '300',
  backgroundColor: 'whitesmoke'
};
